import React from 'react';
import { motion } from 'framer-motion';
import { FEE } from '../data/content';
import { Check, ShieldCheck } from 'lucide-react';

export default function CourseFee() {
  return (
    <section id="fees" className="py-24 md:py-32 bg-page">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="section-label">{FEE.eyebrow}</div>
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5">
            {FEE.title}
            <span className="grad-text-red">{FEE.titleAccent}</span>
          </h2>
        </div>

        <div className="mt-12 rounded-3xl overflow-hidden border border-line bg-white shadow-[0_20px_60px_-30px_rgba(41,56,145,0.2)] grid md:grid-cols-12">
          <div className="md:col-span-7 p-8 md:p-12">
            <div className="inline-flex items-center gap-2 bg-red-soft text-red rounded-full px-4 py-1.5 text-[11px] uppercase tracking-widest font-semibold">
              <ShieldCheck size={14} /> {FEE.honestyLabel}
            </div>

            <div className="mt-6">
              <div className="text-[11px] uppercase tracking-widest font-semibold text-[color:var(--muted)]">
                Course Fee
              </div>
              <div className="mt-3 flex items-end gap-4 flex-wrap">
                <div className="font-display text-[64px] md:text-[84px] leading-none text-navy">
                  {FEE.price}
                </div>
                <div className="pb-3 text-[13px] text-[color:var(--muted)]">{FEE.taxNote}</div>
              </div>
            </div>

            <p className="mt-6 text-[15px] text-[color:var(--muted)] leading-relaxed max-w-xl">
              {FEE.honestyNote}
            </p>

            <div className="mt-8 h-px bg-line" />

            <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {FEE.perks.map((p, i) => (
                <motion.li
                  key={p}
                  initial={{ opacity: 0, x: -8 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.05 }}
                  className="flex items-start gap-3 text-[14.5px]"
                >
                  <span className="w-6 h-6 rounded-full bg-red-soft flex items-center justify-center mt-0.5 flex-shrink-0">
                    <Check size={13} className="text-red" />
                  </span>
                  {p}
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-5 bg-[#1F2B73] text-white p-8 md:p-12 relative overflow-hidden flex flex-col justify-center">
            <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-red/25 blur-3xl" />
            <div className="relative">
              <div className="text-[11px] uppercase tracking-widest font-semibold text-white/60">
                Enrollment
              </div>
              <div className="mt-5 font-display text-[24px] md:text-[28px] leading-snug">
                {FEE.rmNote}
              </div>
              <div className="mt-8 flex flex-wrap items-center gap-3">
                <div className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/[0.04] px-4 py-2">
                  <span className="w-2 h-2 rounded-full bg-red animate-pulse" />
                  <span className="text-[13px] text-white/90">Enrollments open</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
